// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1373":"23fbc84c","2775":"948984cf","2796":"3ca20e80","3040":"3ca20e80","7350":"36d9e990"}[chunkId] + ".chunk.css";
};